import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a7739c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["draggable"]
const _hoisted_2 = { class: "filter-btn__content" }
const _hoisted_3 = {
  class: "sprite-icon icon filter-btn__icon",
  width: "20",
  height: "20"
}
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = { class: "filter-btn__title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon filter-btn__settings",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#settings" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_range_slider = _resolveComponent("app-range-slider")!
  const _component_vue_tippy = _resolveComponent("vue-tippy")!
  const _directive_app_tippy_visible = _resolveDirective("app-tippy-visible")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter__col app-tippy-hide-border-one-side dashboard-range-slider", {
            'select-mode': _ctx.selectMode,
            'select-mode-1': _ctx.selectModeForMainFilter === 1,
            'select-mode-2': _ctx.selectModeForMainFilter === 2,
            'select-mode-3': _ctx.selectModeForMainFilter === 3,
            'select-mode-4': _ctx.selectModeForMainFilter === 4,
        }]),
    draggable: !_ctx.isOpen
  }, [
    _withDirectives((_openBlock(), _createBlock(_component_vue_tippy, {
      interactive: "",
      placement: "bottom",
      animation: "shift-away",
      trigger: "manual",
      "max-width": "none",
      "hide-on-click": false,
      tag: "div",
      arrow: false,
      theme: "light",
      offset: [0, 0],
      onClick: _ctx.buttonClick
    }, {
      content: _withCtx(() => [
        _createVNode(_component_app_range_slider, {
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event)),
          options: _ctx.options,
          unit: _ctx.rangeUnit
        }, null, 8, ["modelValue", "options", "unit"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["filter-btn no-fill", _ctx.filterClasses])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, [
              _createElementVNode("use", {
                "xlink:href": `/img/sprite.svg#filter-${_ctx.iconName}`
              }, null, 8, _hoisted_4)
            ])),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_i18n_t, {
                keypath: 'dashboard.settings.filters.' + _ctx.type
              }, null, 8, ["keypath"])
            ])
          ]),
          _createElementVNode("div", {
            class: "filter-btn__block",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.innerButtonClick && _ctx.innerButtonClick(...args)))
          }, _hoisted_7)
        ], 2)
      ]),
      _: 1
    }, 8, ["onClick"])), [
      [_directive_app_tippy_visible, _ctx.isOpen]
    ])
  ], 10, _hoisted_1)), [
    [_directive_click_outside, () => (_ctx.isOpen = false)]
  ])
}